import { Box, Grid, Typography } from "@mui/material";
import { useAuthContext } from "../../hooks/Auth";
import Banner from "../Banner/Banner";
import UmmIAAgentBanner from "../Banner/img/UmmIAAgentBanner.svg"

const HeaderHome = () => {
  const { user } = useAuthContext();

  if (!user) return null;

  return (
    <Box sx={{ width: "100%" }}>
      <Grid
        container
        direction="column"
        sx={{
          width: "100%",
          gap: 2,
        }}
      >
        {/* Saludo arriba */}
        <Grid item>
          <Typography
            variant="h3"
            component="h1"
            color="#336B87"
            fontSize={{ xs: "1.4rem", sm: "1.8rem", md: "2.1rem" }}
            fontWeight="bold"
            sx={{
              fontFamily: "Montserrat",
              textAlign: "left",
              textTransform: "uppercase",
            }}
          >
            {`Hola, ${user.name ?? ""}`}
          </Typography>
        </Grid>

        {/* Banner */}
        <Grid item sx={{ width: "100%" }}>
          <Box sx={{ width: "100%" }}>
            <Banner
              imageSrc={UmmIAAgentBanner}
              backgroundColorImage="linear-gradient(360deg, #fcfcfc 20%, #9ac4d9 70%, #336b87a2 100%)"
              title="Conoce nuestro nuevo editor UmmIA Agent"
              secondaryTitle= "PRUEBA NUESTRA VERSIÓN beta: Conversa, mejora y evoluciona "
              subtitle="Tu nuevo asistente inteligente para planificaciones y trabajos. "
              description="Edita, conversa, guarda versiones y vuelve a usarlo cuando quieras en el Modo Editor. Más que una herramienta, una experiencia personalizada para usar y mejorar tus planificaciones y trabajos."
              titleColor="#234C61"
              buttonText="Ver Tutorial Ahora"
              onButtonClick={() => console.log("Ir al tutorial")}
            />
          </Box>
        </Grid>

        {/**
        <Grid item>
          <Box>
            <Gauge
              value={user?.creditosUsados ?? 0}
              valueMax={
                (user?.creditosDisponibles ?? 0) + (user?.creditosUsados ?? 0)
              }
              startAngle={-90}
              endAngle={90}
              sx={{
                width: { xs: 150, sm: 150, md: 170 },
                height: { xs: 90, sm: 90, md: 100 },
                [`& .${gaugeClasses.valueText}`]: {
                  fontSize: 11,
                  fontFamily: "Montserrat",
                },
                [`& .${gaugeClasses.valueArc}`]: { fill: "#336B87" },
                [`& .${gaugeClasses.referenceArc}`]: { fill: "#90AFC5" },
              }}
              text={({ value, valueMax }) =>
                `${value} / ${valueMax} créditos`
              }
            />
          </Box>
        </Grid>
        */}
      </Grid>
    </Box>
  );
};

export default HeaderHome;
